/**
 * This helper toggles the sort icon on a sortable table
 *
 * Example usage in a template
 * <th role="button"
 *     {{on "click" (fn this.statefulSort tableAction "sortByValue || sortByNumber || sortByDate || sortByGrade || sort" "columnName")}}
 * >
 *   Column Name
 *   <PhosphorIcon @icon={{if (eq currentSortColumn "columnName") currentSortIcon "phosphor-caret-up-down-fill"}} />
 * </th>
 */

interface StatefulSorter {
  currentSortIcon?: string
  currentSortColumn?: string
}

export type TableActionOperation = string | ((...args: any) => void)

export type TableAction = (tableActionOperation: TableActionOperation, tableActionKey: string) => void

export function statefulSort(
  owner: StatefulSorter,
  tableAction: TableAction,
  tableActionOperation: TableActionOperation,
  tableActionKey: string,
) {
  tableAction(tableActionOperation, tableActionKey)

  let newSortIcon = 'phosphor-caret-up-fill' // default sort direction 'asc'

  // If the column has already been sorted, toggle the direction
  if (owner.currentSortColumn === tableActionKey && owner.currentSortIcon === 'phosphor-caret-up-fill') {
    newSortIcon = 'phosphor-caret-down-fill' // sort direction 'desc'
  }

  owner.currentSortColumn = tableActionKey
  owner.currentSortIcon = newSortIcon
}
